module.exports = __webpack_public_path__ + "static/media/website-08.41e7017a.png";